// extracted by mini-css-extract-plugin
export default {"overlay":"Loading_overlay__8Hsb1","spinner":"Loading_spinner__s5eU9","spin":"Loading_spin__sCrfu","text":"Loading_text__ZiRUT"};